"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const PageContent_1 = __importDefault(require("../PageContent"));
const hookrouter_1 = require("hookrouter");
const SecurePage_1 = require("../SecurePage");
const boldText = {
    root: { fontWeight: office_ui_fabric_react_1.FontWeights.semibold }
};
const HomePage = () => react_1.default.createElement(SecurePage_1.SecurePage, null,
    react_1.default.createElement(PageContent_1.default, { title: "Harvester" },
        react_1.default.createElement(office_ui_fabric_react_1.Text, { block: true, variant: "large" }, "This application is used to integrate Harvest and Pronto."),
        react_1.default.createElement("div", { style: { marginTop: '30px' } },
            react_1.default.createElement(office_ui_fabric_react_1.Text, { variant: "large", styles: boldText }, "Options"),
            react_1.default.createElement(office_ui_fabric_react_1.Stack, { horizontal: true, gap: 15, styles: { root: { marginTop: '15px' } } },
                react_1.default.createElement(office_ui_fabric_react_1.CompoundButton, { onClick: () => hookrouter_1.navigate('/import-time-entries'), secondaryText: "Import time entries for Nukon" }, "Import Time Entries"),
                react_1.default.createElement(office_ui_fabric_react_1.CompoundButton, { onClick: () => hookrouter_1.navigate('/logs'), secondaryText: "View debug and error logs" }, "Logs"),
                react_1.default.createElement(office_ui_fabric_react_1.CompoundButton, { onClick: () => hookrouter_1.navigate('/settings'), secondaryText: "Edit employee mapping info" }, "Settings")),
            react_1.default.createElement("div", { style: { marginTop: '30px' } },
                react_1.default.createElement(office_ui_fabric_react_1.Text, { style: { color: '#aaa' } }, "Version: 0.4.0")))));
exports.default = HomePage;
